/* RunAction.js */

"use strict";

const RUN_WHOLE_MESSAGE = "Are you sure you want to run the selected schedule now? This action will not impact future schedules from being run.";
const RUN_TITLE = "Run Now";
const WorkTrigFutureViewComponent = require("../../views/worktrig_future/WorkTrigFutureViewComponent");

class RunAction {
    constructor(logger, gameEditor, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._activeView = activeView;
        this._workTrig = gameEditor.getTriggerType();

        // custom behavior for Future Occurrences view
        if (this._activeView && this._activeView instanceof WorkTrigFutureViewComponent && this._activeView.pagingFeed) {
            this._selectedFutureIds = this._activeView.getSelectedFutureIds().selectedRows || [];
        }
    }

    run() {
        return this._gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: RUN_WHOLE_MESSAGE,
                title: RUN_TITLE,
                confirmDetails: {
                    text: "Confirm",
                    type: "additive"
                },
                rejectDetails: {
                    text: "Cancel",
                    type: "text"
                }
            },
            () => {
                // temporary disable as it increase user experience complexity
                //
                // if (this._selectedFutureIds && this._selectedFutureIds.length === 1) {
                //     let entity = this._activeView.pagingFeed.getEntityById(this._selectedFutureIds[0]);
                //     if (entity) {
                //         return entity.runNow();
                //     } else {
                //         return Promise.reject('Can\'t find selected future Work Trigger!');
                //     }
                // } else {
                return this._workTrig.runWorkNow();
                // }
            }
        );
    }
}

module.exports = RunAction;

RunAction.$inject = ["$teve.logger", "gameEditor.gameEditor", "gameEditor.activeView"];

RunAction.$displayDetails = {
    type: "Action",
    name: "RunAction",
    icon: "worktrigger.run",
    title: "Run Now",
    shown: true,
    order: 1
};
